import React, { useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Loader2, Send, Smartphone, MessageSquare, Hash } from "lucide-react";
import Swal from "sweetalert2";
import { apiFetch } from "../../api/api";
import { AxiosError } from "axios";

const SmsSender = () => {
    const [surveyId, setSurveyId] = useState<string>("");
    const [mobiles, setMobiles] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const handleSendSms = async () => {
        const sid = surveyId.trim();
        const m = mobiles.trim();
        const tx = text.trim();

        if (!sid || !m || !tx) {
            Swal.fire({
                icon: "warning",
                text: "لطفاً تمام فیلدها را پر کنید."
            });
            return;
        }

        setLoading(true);

        // تبدیل شماره‌ها به فرمت مورد نیاز
        const formattedMobiles = m
            .split(/\r?\n/)
            .map((mobile) => mobile.trim())
            .filter((mobile) => mobile !== "")
            .map((mobile) => `${mobile},null,null;`)
            .join("");

        console.log("formattedMobiles =>", formattedMobiles);
// tx                  // متن پیام
        try {
            const res = await apiFetch({
                data: {
                    params: [
                        null,                //sent_id
                        Number(sid),        // شناسه پرسشنامه
                        null,               // date
                        formattedMobiles,   // شماره‌ها
                        null,
                        1,
                        5,
                        tx
                    ]
                }
            });
            const data = res ?? {};

            if (data?.success) {
                Swal.fire({
                    icon: "success",
                    title: "ارسال موفقیت‌آمیز",
                    text: "پیامک با موفقیت ارسال شد."
                });

                setSurveyId("");
                setMobiles("");
                setText("");
            } else {
                throw new Error(data?.message || "خطایی از سمت سرور بازگشت.");
            }

        } catch (e) {
            const axiosError = e as AxiosError;

            Swal.fire({
                icon: "error",
                title: "خطا در ارسال",
                text: axiosError?.message ?? "خطا در ارتباط با سرور"
            });

        } finally {
            setLoading(false);
        }
    };

    // محدود کردن شناسه به عدد
    const onSurveyIdChange = (val: string) => {
        setSurveyId(val.replace(/[^\d]/g, ""));
    };

    return (
        <>
            <BreadCrumb title="ارسال پیامک مستقیم" pageTitle="Direct SMS" />

            <div className="w-full max-w-2xl mx-auto mt-8 bg-white dark:bg-zink-800 rounded-xl p-8 shadow-sm border border-slate-200 dark:border-zink-700">

                <div className="flex items-center gap-2 mb-6 border-b pb-4 border-slate-100 dark:border-zink-700">
                    <Send className="text-custom-500" size={20} />
                    <h2 className="text-lg font-bold text-slate-700 dark:text-zink-100">
                        پنل ارسال مستقیم
                    </h2>
                </div>

                <div className="space-y-5">

                    {/* شناسه پرسشنامه */}
                    <div>
                        <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
                            <Hash size={16} />
                            شناسه پرسشنامه
                        </label>

                        <input
                            value={surveyId}
                            onChange={(e) => onSurveyIdChange(e.target.value)}
                            className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg outline-none focus:ring-2 focus:ring-custom-500"
                            placeholder="مثلاً: 123"
                        />
                    </div>

                    {/* شماره موبایل */}
                    <div>
                        <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
                            <Smartphone size={16} />
                            شماره‌های گیرنده
                        </label>

                        <textarea
                            value={mobiles}
                            onChange={(e) => setMobiles(e.target.value)}
                            rows={5}
                            className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg outline-none focus:ring-2 focus:ring-custom-500"
                            placeholder={`09123456789
09350000000`}
                        />

                        <p className="mt-1 text-[11px] text-slate-400">
                            هر شماره را در یک خط وارد کنید.
                        </p>
                    </div>

                    {/* متن پیام */}
                    <div>
                        <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
                            <MessageSquare size={16} />
                            متن پیامک
                        </label>

                        <textarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows={4}
                            className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg outline-none focus:ring-2 focus:ring-custom-500"
                            placeholder="متن پیامک..."
                        />
                    </div>

                    {/* دکمه ارسال */}
                    <button
                        onClick={handleSendSms}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 bg-custom-500 text-white py-3 rounded-lg hover:bg-custom-600 disabled:bg-slate-300 font-bold transition-all shadow-md"
                    >
                        {loading ? (
                            <>
                                <Loader2 className="animate-spin" />
                                در حال ارسال...
                            </>
                        ) : (
                            <>
                                <Send size={18} />
                                تایید و ارسال پیامک
                            </>
                        )}
                    </button>

                </div>
            </div>
        </>
    );
};

export default SmsSender;


// import React, { useState } from "react";
// import { apiFetch } from "../../api/api";
// import BreadCrumb from "Common/BreadCrumb";
// import { Loader2, Send, Smartphone, MessageSquare, Hash } from "lucide-react";
// import Swal from "sweetalert2";
//
// const ONLY_DIGITS_REGEX = /^[0-9]+$/;
//
// const SmsSender = () => {
//     const [surveyId, setSurveyId] = useState<string>("");
//     const [mobiles, setMobiles] = useState<string>("");
//     const [text, setText] = useState<string>("");
//     const [loading, setLoading] = useState<boolean>(false);
//
//     const handleSendSms = async () => {
//         const sid = surveyId.trim();
//         const m = mobiles.trim();
//         const tx = text.trim();
//
//         if (!sid || !m || !tx) {
//             Swal.fire({
//                 icon: "warning",
//                 title: "دقت کنید",
//                 text: "لطفاً همه فیلدها را تکمیل کنید.",
//                 confirmButtonText: "متوجه شدم",
//             });
//             return;
//         }
//
//         if (!ONLY_DIGITS_REGEX.test(sid)) {
//             Swal.fire({
//                 icon: "error",
//                 title: "ورودی نامعتبر",
//                 text: "شناسه پرسشنامه فقط باید عدد باشد.",
//                 confirmButtonText: "باشه",
//             });
//             return;
//         }
//
//         setLoading(true);
//
//         const formattedMobiles = m
//             .replace(/\s+/g, ",")
//             .replace(/,+/g, ",")
//             .replace(/^,|,$/g, "");
//
//         try {
//             const res = await apiFetch({
//              url : "https://test.ir/API/V2.0/Send.ashx?number=42333342&mobiles=" . urlencode(formattedMobiles) . "&text=" . urlencode(text);
//                 method: "GET",
//                 data: {
//                     ajax: 1,
//                     surveyId: Number(sid),
//                     mobiles: formattedMobiles,
//                     text: tx,
//                 },
//             });
//
//             if (res?.success || res?.status === "success") {
//                 Swal.fire({
//                     icon: "success",
//                     title: "ارسال موفقیت‌آمیز",
//                     html: `پیامک با موفقیت ارسال شد.<br/>ServerID:<br>${res?.ids?.join(", ") || "---"}`,
//                     confirmButtonText: "عالی",
//                 });
//
//                 setSurveyId("");
//                 setMobiles("");
//                 setText("");
//             } else {
//                 throw new Error(res?.message || "خطا در ارسال پیامک");
//             }
//         } catch (error: any) {
//             Swal.fire({
//                 icon: "error",
//                 title: "خطا",
//                 text: error?.message || "اتصال به وب‌سرویس برقرار نشد!",
//                 confirmButtonText: "تلاش مجدد",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     const onSurveyIdChange = (val: string) => {
//         const normalized = val.replace(/[^\d]/g, "");
//         setSurveyId(normalized);
//     };
//
//     return (
//         <>
//             <BreadCrumb title="ارسال پیامک" pageTitle="SMS Management" />
//
//             <div className="w-full max-w-2xl mx-auto mt-8 bg-white dark:bg-zink-800 rounded-xl p-8 shadow-sm border border-slate-200 dark:border-zink-700">
//                 <div className="flex items-center gap-2 mb-6 border-b pb-4 border-slate-100 dark:border-zink-700">
//                     <Send className="text-custom-500" size={20} />
//                     <h2 className="text-lg font-bold text-slate-700 dark:text-zink-100">
//                         ارسال پیامک جدید
//                     </h2>
//                 </div>
//
//                 <div className="space-y-5">
//                     {/* شناسه پرسشنامه */}
//                     <div>
//                         <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
//                             <Hash size={16} />
//                             شناسه پرسشنامه
//                         </label>
//                         <input
//                             value={surveyId}
//                             onChange={(e) => onSurveyIdChange(e.target.value)}
//                             className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg focus:ring-2 focus:ring-custom-500 focus:border-transparent outline-none transition-all"
//                             placeholder="مثلاً: 123"
//                             inputMode="numeric"
//                             dir="ltr"
//                         />
//                         <p className="mt-2 text-xs text-slate-500 leading-6">
//                             فقط عدد وارد کنید.
//                         </p>
//                     </div>
//
//                     {/* شماره موبایل‌ها */}
//                     <div>
//                         <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
//                             <Smartphone size={16} />
//                             شماره‌های موبایل
//                         </label>
//                         <textarea
//                             value={mobiles}
//                             onChange={(e) => setMobiles(e.target.value)}
//                             rows={5}
//                             className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg focus:ring-2 focus:ring-custom-500 focus:border-transparent outline-none transition-all"
//                             placeholder={"09123456789\n09120000000"}
//                         />
//                         <p className="mt-2 text-xs text-slate-500 leading-6">
//                             شماره‌ها را با Enter یا فاصله یا کاما از هم جدا کنید.
//                         </p>
//                     </div>
//
//                     {/* متن پیام */}
//                     <div>
//                         <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
//                             <MessageSquare size={16} />
//                             متن پیامک
//                         </label>
//                         <textarea
//                             value={text}
//                             onChange={(e) => setText(e.target.value)}
//                             rows={4}
//                             className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg focus:ring-2 focus:ring-custom-500 focus:border-transparent outline-none transition-all"
//                             placeholder="متن پیام خود را اینجا بنویسید..."
//                         />
//                     </div>
//
//                     {/* دکمه ارسال */}
//                     <button
//                         onClick={handleSendSms}
//                         disabled={loading}
//                         className="w-full flex items-center justify-center gap-2 bg-custom-500 text-white py-3 rounded-lg hover:bg-custom-600 disabled:bg-slate-400 disabled:cursor-not-allowed transition-all shadow-md font-bold"
//                     >
//                         {loading ? (
//                             <>
//                                 <Loader2 className="animate-spin" size={20} />
//                                 در حال پردازش...
//                             </>
//                         ) : (
//                             <>
//                                 <Send size={20} />
//                                 تایید و ارسال پیامک
//                             </>
//                         )}
//                     </button>
//                 </div>
//             </div>
//         </>
//     );
// };
//
// export default SmsSender;

// import React, { useState } from "react";
// import { apiFetch } from "../../api/api"; // فرض بر این است که متد apiFetch شما هندل کننده درخواست‌هاست
// import BreadCrumb from "Common/BreadCrumb";
// import { Loader2, Send, Smartphone, MessageSquare } from "lucide-react";
// import Swal from "sweetalert2"; // پیشنهاد می‌شود برای مودال‌ها از sweetalert2 استفاده کنی
//
// const SmsSender = () => {
//     const [mobiles, setMobiles] = useState<string>("");
//     const [text, setText] = useState<string>("");
//     const [loading, setLoading] = useState<boolean>(false);
//
//     const handleSendSms = async () => {
//         if (!mobiles.trim() || !text.trim()) {
//             Swal.fire({
//                 icon: 'warning',
//                 title: 'دقت کنید',
//                 text: 'لطفاً شماره‌ها و متن پیام را وارد کنید.',
//                 confirmButtonText: 'متوجه شدم'
//             });
//             return;
//         }
//
//         setLoading(true);
//
//         // تمیز کردن شماره‌ها مشابه منطق PHP شما
//         const formattedMobiles = mobiles
//             .trim()
//             .replace(/\s+/g, ',') // تبدیل فضاها به کاما
//             .replace(/,+/g, ','); // حذف کاماهای تکراری
//
//         try {
//             console.log(formattedMobiles);
//             const res = await apiFetch({
//                 url: "SendSms", // یا هر آدرسی که در Backend تعریف کردید
//                 method: "POST",
//                 data: {
//                     mobiles: formattedMobiles,
//                     text: text,
//                     ajax: 1
//                 },
//             });
//
//             if (res.success || (res.status === "success")) {
//                 Swal.fire({
//                     icon: 'success',
//                     title: 'ارسال موفقیت‌آمیز',
//                     html: `پیامک با موفقیت ارسال شد.<br/>کد پیگیری: ${res.ids?.join(', ') || '---'}`,
//                     confirmButtonText: 'عالی'
//                 });
//                 // پاکسازی فرم
//                 setMobiles("");
//                 setText("");
//             } else {
//                 throw new Error(res.message || "خطا در ارسال پیامک");
//             }
//         } catch (error: any) {
//             Swal.fire({
//                 icon: 'error',
//                 title: 'خطا',
//                 text: error.message || "اتصال به وب‌سرویس برقرار نشد!",
//                 confirmButtonText: 'تلاش مجدد'
//             });
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     return (
//         <>
//             <BreadCrumb title="ارسال پیامک" pageTitle="SMS Management" />
//
//             <div className="w-full max-w-2xl mx-auto mt-8 bg-white dark:bg-zink-800 rounded-xl p-8 shadow-sm border border-slate-200 dark:border-zink-700">
//                 <div className="flex items-center gap-2 mb-6 border-b pb-4 border-slate-100 dark:border-zink-700">
//                     <Send className="text-custom-500" size={20} />
//                     <h2 className="text-lg font-bold text-slate-700 dark:text-zink-100">ارسال پیامک جدید</h2>
//                 </div>
//
//                 <div className="space-y-5">
//                     {/* بخش شماره موبایل‌ها */}
//                     <div>
//                         <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
//                             <Smartphone size={16} />
//                             شماره‌های موبایل
//                         </label>
//                         <textarea
//                             value={mobiles}
//                             onChange={(e) => setMobiles(e.target.value)}
//                             rows={5}
//                             className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg focus:ring-2 focus:ring-custom-500 focus:border-transparent outline-none transition-all"
//                             placeholder="09123456789&#10;09120000000"
//                         />
//                         <p className="mt-2 text-xs text-slate-500 leading-6">
//                             شماره‌ها را با Enter یا کاما از هم جدا کنید.
//                             فرمت صحیح: 09123456789
//                         </p>
//                     </div>
//
//                     {/* بخش متن پیام */}
//                     <div>
//                         <label className="flex items-center gap-2 mb-2 text-sm font-medium text-slate-600 dark:text-zink-200">
//                             <MessageSquare size={16} />
//                             متن پیامک
//                         </label>
//                         <textarea
//                             value={text}
//                             onChange={(e) => setText(e.target.value)}
//                             rows={4}
//                             className="w-full p-3 border border-slate-200 dark:border-zink-700 dark:bg-zink-900 rounded-lg focus:ring-2 focus:ring-custom-500 focus:border-transparent outline-none transition-all"
//                             placeholder="متن پیام خود را اینجا بنویسید..."
//                         />
//                     </div>
//
//                     {/* دکمه ارسال */}
//                     <button
//                         onClick={handleSendSms}
//                         disabled={loading}
//                         className="w-full flex items-center justify-center gap-2 bg-custom-500 text-white py-3 rounded-lg hover:bg-custom-600 disabled:bg-slate-400 disabled:cursor-not-allowed transition-all shadow-md font-bold"
//                     >
//                         {loading ? (
//                             <>
//                                 <Loader2 className="animate-spin" size={20} />
//                                 در حال پردازش...
//                             </>
//                         ) : (
//                             <>
//                                 <Send size={20} />
//                                 تایید و ارسال پیامک
//                             </>
//                         )}
//                     </button>
//                 </div>
//             </div>
//         </>
//     );
// };
//
// export default SmsSender;
